import { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import moment from 'moment'
import TextField from '../../../../sharedComponent/TextField/TextField'

interface AgentInfoProps {
  data: any
  featureFlags: any
}

const defaultAgentInfo = {
  agentFirstName: '',
  agentLastName: '',
  agentEmailId: '',
  salesChannel: '',
  tpvCreated: '',
  leadCreated: '',
  agentLeaderCode: '',
  agentLeader: '',
}

const AgentInfo = ({ data, featureFlags }: AgentInfoProps) => {
  const [dataFeed, setDataFeed] = useState<boolean>(false)
  const agentFiledDetails: any = [
    {
      fieldTitle: 'First Name',
      filedTitleMandatory: false,
      fieldName: 'agentFirstName',
      placeHolder: 'Enter agent first name',
      maxLength: '50',
      disabled: true,
    },
    {
      fieldTitle: 'Last Name',
      filedTitleMandatory: false,
      fieldName: 'agentLastName',
      placeHolder: 'Enter agent last name',
      maxLength: '50',
      disabled: true,
    },
    {
      fieldTitle: 'User Name',
      filedTitleMandatory: false,
      fieldName: 'loginUsername',
      placeHolder: 'Enter agent User Id',
      maxLength: '50',
      disabled: true,
    },
    {
      fieldTitle: 'Rep Id',
      filedTitleMandatory: false,
      fieldName: 'agentRepId',
      placeHolder: 'Enter agent Rep Id',
      maxLength: '50',
      disabled: true,
    },
    {
      fieldTitle: 'Email ID',
      filedTitleMandatory: false,
      fieldName: 'agentEmailId',
      placeHolder: 'Enter agent email id',
      maxLength: '50',
      disabled: true,
    },
    {
      fieldTitle: 'Sales Channel',
      filedTitleMandatory: false,
      fieldName: 'salesChannel',
      placeHolder: 'Enter sales channel',
      maxLength: '50',
      disabled: true,
    },
    {
      fieldTitle: 'TPV Created',
      filedTitleMandatory: false,
      fieldName: 'tpvCreated',
      placeHolder: 'Enter TPV created date',
      maxLength: '50',
      disabled: true,
    },
    {
      fieldTitle: 'Lead Created',
      filedTitleMandatory: false,
      fieldName: 'leadCreated',
      placeHolder: 'Enter lead created',
      maxLength: '50',
      disabled: true,
    },
  ]

  const agentInfoSchema = Yup.object().shape({})

  const formik = useFormik({
    initialValues: defaultAgentInfo,
    validationSchema: agentInfoSchema,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      console.log('Customer Info Submitted')
    },
  })

  useEffect(() => {
    if (!dataFeed && data) {
      const agentDetails = {
        agentFirstName: data.agentFirstName,
        agentLastName: data.agentLastName,
        agentEmailId: !!data.loginUsername ? '-' : data.agentEmailId,
        salesChannel: data.salesChannelName,
        agentLeaderCode: data.agentLeaderCode,
        agentRepId: data.agentRepId,
        agentLeader: data.agentLeader,
        loginUsername: data.loginUsername ? data.loginUsername : '-',
        tpvCreated: data.tpvDate
          ? `${moment.utc(data?.tpvDate).local().format('DD MMM YYYY, hh:mm A')}`
          : '',
        leadCreated: data.leadCreatedDate
          ? `${moment.utc(data?.leadCreatedDate).local().format('DD MMM YYYY, hh:mm A')}`
          : '',
      }
      formik.setValues({ ...agentDetails })
      setDataFeed(true)
    }
  }, [data, dataFeed])

  const handleOnChange = (e: any, name: string) => {
    formik.setFieldValue(name, e.target.value)
  }
  return (
    <div>
      <div className='current p-4' data-kt-stepper-element='content'>
        <form className='' onSubmit={formik.handleSubmit}>
          {/* Modal Header Start */}
          <div className='row mb-5'>
            {/* Title */}
            <div className='col-6'>
              <label className='d-flex align-items-center fs-4 fw-bold mb-4 lh-1'>
                <span className='fs-3 fw-bolder text-gray-900'>Agent Info</span>
              </label>
            </div>
          </div>
          {/* Modal Header End */}
          <Row>
            {agentFiledDetails.map((itemCol: any, idx: number) => (
              <Col sm={4} md={4} className={idx === 2 ? 'pb-5 pr-0' : 'pb-5'} key={idx}>
                <TextField
                  fieldTitle={itemCol.fieldTitle}
                  filedTitleMandatory={itemCol.filedTitleMandatory}
                  fieldName={itemCol.fieldName}
                  placeHolder={itemCol.placeHolder}
                  maxLength={itemCol.maxLength}
                  fieldValue={formik.getFieldMeta(itemCol.fieldName).value}
                  disabled={itemCol.disabled}
                  handleOnChange={handleOnChange}
                  formik={formik}
                />
              </Col>
            ))}
            {Boolean(formik.values.agentLeader) && (
              <Col sm={4} md={4} className={'pb-5'} key={'agentLeader'}>
                <TextField
                  fieldTitle={'Agent Leader Name'}
                  filedTitleMandatory={false}
                  fieldName={'agentLeader'}
                  placeHolder={'Enter Agent Leader'}
                  fieldValue={formik.values.agentLeader}
                  disabled={true}
                  handleOnChange={handleOnChange}
                  formik={formik}
                />
              </Col>
            )}
            {Boolean(formik.values.agentLeaderCode) && (
              <Col sm={4} md={4} className={'pb-5'} key={'agentLeaderCode'}>
                <TextField
                  fieldTitle={'Agent Leader Code'}
                  filedTitleMandatory={false}
                  fieldName={'agentLeaderCode'}
                  placeHolder={'Enter Agent Leader Code'}
                  fieldValue={formik.values.agentLeaderCode}
                  disabled={true}
                  handleOnChange={handleOnChange}
                  formik={formik}
                />
              </Col>
            )}
          </Row>
        </form>
      </div>
    </div>
  )
}

export default AgentInfo
